var _style, _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMicrosoftAuthenticator(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 71.6 64.4",
    style: {
      enableBackground: "new 0 0 71.6 64.4"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#205694;}\n\t.st1{fill:url(#SVGID_1_);}\n\t.st2{fill:url(#SVGID_00000036252649482576691510000016728131539071934907_);}\n\t.st3{fill:url(#SVGID_00000173851938480723987980000013706547800314840763_);}\n\t.st4{fill:url(#SVGID_00000048498487212454211220000006519116340668673968_);}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M20.5,19.6c0-4,3.8-14.6,15.2-14.6s15.7,10.8,15.5,14.4C51.1,23,45,21.8,45,21.8s1,0.8,0.1-3.2 c-0.7-2.8-3.4-7.3-9.1-7.3s-8.4,4.6-9,7.1S20.5,19.6,20.5,19.6z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 35.789,
    y1: 59.4625,
    x2: 35.789,
    y2: 18.3537
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.2096,
    style: {
      stopColor: "#115A9E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#2C76BC"
    }
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M35.4,59.5c-12.2,0-23-21.7-22.1-29.8s3.2-11.3,22.1-11.3h0.7c18.9,0,21.1,3.2,22.1,11.3 c1,8.1-9.9,29.8-22.1,29.8H35.4z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000150095014752232591590000012426834878687609224_",
    gradientUnits: "userSpaceOnUse",
    x1: 35.9678,
    y1: 37.7957,
    x2: 35.9678,
    y2: 37.7957
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#3297D4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#47C3F1"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000150095014752232591590000012426834878687609224_)"
    },
    d: "M36,37.8"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000145055292812585211090000001248086337689070488_",
    gradientUnits: "userSpaceOnUse",
    x1: 35.9319,
    y1: 59.4625,
    x2: 35.9319,
    y2: 40.0962
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#33A8DF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#47C3F1"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000145055292812585211090000001248086337689070488_)"
    },
    d: "M50.2,50.4c-3.9,5.1-8.8,9.1-14,9.1h-0.7 c-5.1,0-9.9-3.7-13.7-8.7c0,0,2-10.7,14.2-10.7S50.2,50.4,50.2,50.4z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000064348184485006297250000009357360952017226935_",
    gradientUnits: "userSpaceOnUse",
    x1: 35.9678,
    y1: 37.6769,
    x2: 35.9678,
    y2: 22.8681
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#3297D4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#47C3F1"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "url(#SVGID_00000064348184485006297250000009357360952017226935_)"
    },
    cx: 36,
    cy: 30.3,
    r: 7.4
  }));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMicrosoftAuthenticator);
export default __webpack_public_path__ + "static/media/microsoft-authenticator.c022516f9809e74356c03c384c072ee5.svg";
export { ForwardRef as ReactComponent };